










import { Component, Prop, Vue } from "vue-property-decorator";

@Component({
  name: 'ResetPassword'
})
export default class ResetPassword extends Vue {
  @Prop({ type: String })
  public message;
}
